<template lang="pug">
    //CrudForm(
        v-bind="staticData"
        :fields="fields"
            :customRules="customRules"
            @submitForm="handleSubmit($event)"
        :editable="$can('EDIT_PRODUCT_TAG')"
        :readOnly="!$can('EDIT_PRODUCT_TAG')"
        :noButtons="!$can('EDIT_PRODUCT_TAG')"
        )
    model-form(
        title="Detalle de tag"
        :fields="fields"
        ref="form"
        reset-text="restablecer"
        submit-text="editar tag"
        v-bind="formData"
        :switchEdit="$can('EDIT_PRODUCT_TAG')"
        :editable="false"
        v-model="modelData"
        @reset="reset"
        @submit="handleSubmit"
        )
</template>

<script>
//
import { ModelForm } from '@/components/reusable_components/next'
import TagServices from '@/services/api/tag/TagServices'
import FieldsShow from './FieldsCreate'
import MdlTag from '../../models/Warehouse/WhTag'
//-
import { mapActions } from 'vuex'
export default {
    name: 'component-name',
    props: {},
    data: function() {
        return {
            modelData: {},
            form: null,
            fields: FieldsShow,
        }
    },
    computed: {
        formData() {
            return {
                // editable: true,
                // switchEdit: true,
                loading: this.formLoading,
            }
        },
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        handleSubmit: async function(data) {
            new MdlTag(data)
                .save()
                .then(this.handleResponse)
                .catch()
        },
        fillStaticFormData() {
            let information = {}
            information.toolbarTitle = 'Tag'
            information.toolbarIcon = 'close'
            information.customRules = function(value) {
                return value.length >= 8 ? true : 'El largo mínimo es 8'
            }
            information.editable = true
            information.disabled = false
            information.submitText = 'Editar Tag'

            return information
        },
        fillFields: async function() {
            TagServices.fetchTag(this.$route.params.id)
                .then(this.setFormData)
                .catch(this.showErrorSnackbar)
        },
        setFormData(model) {
            this.modelData = model.reset()
            this.formLoading = false
        },
        showErrorSnackbar(response) {
            this.initSnackbar(
                this.fillSnack('error', 'Error', response, false, 3000)
            )
        },
        handleResponse(response) {
            if (response.status === 'success')
                return this.showSuccessSnackbar(
                    this.$router.push({ path: '/tags' })
                )
            //
            return this.showErrorSnackbar(response)
        },
        showSuccessSnackbar() {
            this.initSnackbar(
                this.fillSnack(
                    'success',
                    'Éxito',
                    'Etiqueta editada exitosamente.',
                    false,
                    3000
                )
            )
        },
    },
    watch: {},
    components: { 'model-form': ModelForm },
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    mounted: async function() {
        this.fillFields()
        this.setTitleTopBar('Tag')
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_PRODUCT_TAG')) ctx.$router.push('/')
        })
    },
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss"></style>
